"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENTS_DD_AMOUNT_UPDATED = void 0;
exports.PAYMENTS_DD_AMOUNT_UPDATED = 'Payments:DdAmount:Updated';
